<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard label="เด็กทั้งหมด อายุ 0 - 18 ปี" :value="totalCwd" unit="คน" align="left">
        <template #icon>
          <div class="w-6 h-6">
            <PeopleIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="กำลังศึกษาอยู่" :value="studyPct" :unit="studyUnit" align="left">
        <template #icon>
          <div class="w-6 h-6">
            <BookOpenBgIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="ไม่เคยเรียน" :value="neverStudyPct" :unit="neverStudyUnit" align="left">
        <template #icon>
          <div class="w-6 h-6">
            <CircleXIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="ได้รับการเตรียมพร้อมก่อนวัยเรียน" :value="earlyPrepPct" :unit="earlyPrepUnit" align="left">
        <template #icon>
          <div class="w-6 h-6">
            <CircleCheckedIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
    </div>

    <div class="mt-6">
      <ChartCard title="ผู้ดูแลหลัก">
        <div class="h-[400px]">
          <DashboardBarEChart chart-id="dCaregiverChart" type="bar" :data="caregiverData" :options="cmpOptions" fill-height />
        </div>
      </ChartCard>
    </div>

    <SectionTitle title="พัฒนาการและสุขภาพ" />
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard label="มีโรคประจำตัว / โรคร้ายแรง" :value="statDiseasePct" :unit="statDiseaseUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <DiseaseIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="ปรับตัวกับเพื่อนได้ดี" :value="statSocialPct" :unit="statSocialUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <MemberIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="มีอาการสมาธิสั้น" :value="statAdhdPct" :unit="statAdhdUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <BrainIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="เคยป่วยหนักจนใช้ชีวิตไม่ปกติ" :value="statIllPct" :unit="statIllUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <DisabilityIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
      <StatCard label="วัคซีนครบตามเกณฑ์" :value="statVaccinePct" :unit="statVaccineUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <VaccineIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="รักษาต่อเนื่อง (มีโรคประจำตัว)" :value="statTreatPct" :unit="statTreatUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <HealIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="พัฒนาการครบตามเกณฑ์" :value="statDevPct" :unit="statDevUnit" align="left">
        <template #iconRight>
          <div class="w-6 h-6">
            <DevelopmentIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-6">
        <ChartCard title="น้ำหนักและส่วนสูง">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="dGrowthChart" type="bar" :data="growthData" :options="growthOptions" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <ChartCard title="โรคประจำตัว">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="dDiseaseGroupChart" type="bar" :data="diseaseGroupData" :options="diseaseGroupOptions" fill-height />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="สาเหตุที่ไม่รักษาต่อเนื่อง">
          <div class="min-h-[400px]">
            <ProgressList :items="treatmentBarriers" color="#F4D35E" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="พฤติกรรมทางสังคม">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="dBehaviorChart" type="bar" :data="behaviorData" :options="cmpOptions" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ประเภทความพิการ">
          <div class="min-h-[400px]">
            <ProgressList :items="devByType" color="#F4D35E" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>

    <SectionTitle title="ข้อมูลสุขภาพและการช่วยเหลือเพิ่มเติม" />

    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      <StatCard
        v-for="kpi in healthAssistKpis"
        :key="kpi.label"
        :label="kpi.label"
        :value="kpi.value"
        :unit="kpi.sub"
        align="left"
      />
    </div>

    <div class="mt-6">
      <ChartCard title="ความลำบากในการทำความเข้าใจ/สื่อสาร (ทุกช่วงอายุ)">
        <div class="h-[160px]">
          <DashboardBarEChart
            chart-id="dCommDiffChart"
            type="bar"
            :data="commDiffData"
            :options="commDiffOptions"
            fill-height
            :palette="PALETTE"
          />
        </div>
      </ChartCard>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
      <ChartCard title="กลุ่มอายุ 2–4 ปี" subtitle="ความลำบากในการ...">
        <div class="h-[200px]">
          <DashboardBarEChart
            chart-id="dAge24DiffChart"
            type="bar"
            :data="age2_4Data"
            :options="ageGroupDiffOptions"
            fill-height
          />
        </div>
      </ChartCard>
      <ChartCard title="กลุ่มอายุ 5–17 ปี" subtitle="ความลำบากในการ...">
        <div class="h-[180px]">
          <DashboardBarEChart
            chart-id="dAge517DiffChart"
            type="bar"
            :data="age5_17Data"
            :options="ageGroupDiffOptions"
            fill-height
            :palette="PALETTE"
          />
        </div>
      </ChartCard>
    </div>

    <SectionTitle title="สวัสดิการและความคุ้มครอง" />
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 lg:col-span-6">
        <ChartCard title="สวัสดิการรักษาพยาบาล">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="dWelfareChart"
              :series="welfare.series"
              :labels="welfare.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="['#345E7E', '#E2687A', '#E0A64A', '#2FAE7E']"
            />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <ChartCard title="เบี้ยคนพิการ">
          <div class="grid grid-cols-2 gap-4">
            <div class="box bg-white border border-gray-200 rounded-lg px-4 py-4">
              <div class="text-center">
                <div class="text-sm text-gray-600">ได้รับ</div>
              </div>
              <div class="mt-3 text-center">
                <div class="text-3xl leading-none break-all text-dark">{{ allowanceReceivePct }}%</div>
                <p class="text-sm text-gray-600 mt-2">{{ allowanceReceiveCount.toLocaleString('th-TH') }} คน</p>
              </div>
            </div>
            <div class="box bg-white border border-gray-200 rounded-lg px-4 py-4">
              <div class="text-center">
                <div class="text-sm text-gray-600">ยังไม่ได้รับ</div>
              </div>
              <div class="mt-3 text-center">
                <div class="text-3xl leading-none break-all text-dark">{{ allowanceNotReceivePct }}%</div>
                <p class="text-sm text-gray-600 mt-2">{{ allowanceNotReceiveCount.toLocaleString('th-TH') }} คน</p>
              </div>
            </div>
          </div>
          <h3 class="text-sm font-medium text-primary-3 my-3" v-if="allowanceReasons.length">สาเหตุที่ยังไม่ได้รับ</h3>
          <div class="min-h-[400px]">
            <ProgressList :items="allowanceReasons" color="#F4D35E" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import StatCard from "../container/StatCard.vue";
import ChartCard from "../container/ChartCard.vue";
import ChartWithLegend from "../container/ChartWithLegend.vue";
import ProgressList from "../container/ProgressList.vue";
import SectionTitle from "../container/SectionTitle.vue";
import DashboardBarEChart from "../container/DashboardBarEChart.vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { globalNumDecFixed } from "@/utils/format-number.js";

const A = { navy: "#3A506A", blue: "#20A0D7", yellow: "#F4D35E", green: "#11D67A", red: "#F73C4B" };
const PALETTE = ["#3A506A", "#F4D35E", "#11D67A", "#20A0D7", "#AF52DE"];

const bar = (label, color, data, opts = {}) => ({
  label, backgroundColor: color, data, barPercentage: 0.6, categoryPercentage: 0.8, ...opts,
});

const barOptions = ({ legend = false, stacked = false, horizontal = false, aspectRatio = 2 } = {}) => {
  const cat = { stacked, grid: { display: false }, ticks: { font: { size: 12 }, autoSkip: false, maxRotation: horizontal ? 0 : 45, minRotation: horizontal ? 0 : 45 } };
  const val = { stacked, beginAtZero: true, grid: { color: "#E2E8F0" }, ticks: { font: { size: 12 }, precision: 0 } };
  return {
    indexAxis: horizontal ? "y" : "x",
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio,
    plugins: {
      legend: { display: legend, position: "bottom", labels: { usePointStyle: true, boxWidth: 8, font: { size: 12 } } },
      tooltip: { enabled: true },
    },
    scales: horizontal ? { x: val, y: cat } : { x: cat, y: val },
  };
};

const cmpOptions = (() => {
  const opts = barOptions({ legend: true, aspectRatio: 1.6 });
  opts.plugins.tooltip = {
    enabled: true,
    callbacks: {
      label(ctx) {
        return `${ctx.dataset.label}: ${globalNumDecFixed(ctx.parsed.y)} คน`;
      },
    },
  };
  return opts;
})();

const growthOptions = (() => {
  const opts = barOptions({ legend: true, aspectRatio: 1.6 });
  opts.plugins.tooltip = {
    enabled: true,
    callbacks: {
      label(ctx) {
        return `${ctx.dataset.label}: ${globalNumDecFixed(ctx.parsed.y)}`;
      },
    },
  };
  return opts;
})();
const hOptions = (aspectRatio) => barOptions({ horizontal: true, aspectRatio });
const diseaseGroupOptions = {
  ...hOptions(2),
  datasets: { bar: { barPercentage: 0.3, categoryPercentage: 0.5 } },
  plugins: {
    ...hOptions(2).plugins,
    tooltip: {
      enabled: true,
      callbacks: {
        label(ctx) {
          return ` ${globalNumDecFixed(ctx.parsed.x)} คน`;
        },
      },
    },
  },
};
const hbar = (labels, data, colors = PALETTE) => ({
  labels,
  datasets: [bar("", colors, data, { barPercentage: 0.7, categoryPercentage: 0.8 })],
});

const store = useStore();
const filterParams = computed(() => store.getters["dashboardOverviewFilter/getFilterForApiDisability"]);
const authHeaders = () => ({
  Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
  "Content-Type": "application/json",
});
const apiGet = (path) =>
  axios.get(`${process.env.VUE_APP_BASE_API}${path}`, {
    headers: authHeaders(),
    params: filterParams.value,
  }).catch((err) => err);

const toNumber = (v) => Number(v || 0);
const toPercent = (v) => `${(v || 0)}%`;
const makeProgressItems = (items) =>
  (items || []).map((item) => ({
    label: item?.value ?? item?.name ?? item?.label ?? "",
    percent: toNumber(item?.pct ?? item?.percentage),
    value: toNumber(item?.count ?? item?.total ?? item?.valueCount ?? 0),
  }));

const totalCwd = ref(0);
const studyPct = ref("0%");
const studyUnit = ref("");
const neverStudyPct = ref("0%");
const neverStudyUnit = ref("");
const earlyPrepPct = ref("0%");
const earlyPrepUnit = ref("");
const statDiseasePct = ref("0%");
const statDiseaseUnit = ref("");
const statSocialPct = ref("0%");
const statSocialUnit = ref("");
const statAdhdPct = ref("0%");
const statAdhdUnit = ref("");
const statIllPct = ref("0%");
const statIllUnit = ref("");
const statVaccinePct = ref("0%");
const statVaccineUnit = ref("");
const statTreatPct = ref("0%");
const statTreatUnit = ref("");
const statDevPct = ref("0%");
const statDevUnit = ref("");


const allowanceReceivePct = ref(0);
const allowanceReceiveCount = ref(0);
const allowanceNotReceivePct = ref(0);
const allowanceNotReceiveCount = ref(0);

const healthAssistKpis = ref([])
const growthData = ref({
  labels: [],
  datasets: []
});
const diseaseGroupData = ref({
  labels: [],
  datasets: []
});
const treatmentBarriers = ref([])
const behaviorData = ref({
  labels: [],
  datasets: []
});
const devByType = ref([]);
const caregiverData = ref({
  labels: [],
  datasets: []
});
const welfare = ref({
  labels: [],
  series: [],
});
const allowanceReasons = ref([]);
const commDiffData = ref({
  labels: [],
  datasets: []
});
const age2_4Data = ref({
  labels: [],
  datasets: []
});
const age5_17Data = ref({
  labels: [],
  datasets: []
});

const commDiffOptions = {
  indexAxis: 'y',
  scales: {
    x: { stacked: true, display: false, max: 100 },
    y: { stacked: true, display: false },
  },
  plugins: {
    tooltip: { enabled: false },
    datalabels: {
      color: '#fff',
      anchor: 'center',
      align: 'center',
      font: { size: 12, family: 'Kanit' },
      formatter: (value, ctx) => {
        if (value === 0) return null;
        if (value < 6) return `${value}%`;
        const names = ['ไม่มี', 'เล็กน้อย', 'มาก', ''];
        const name = names[ctx.datasetIndex] ?? '';
        return name ? `${name} ${value}%` : `${value}%`;
      },
    },
  },
};
const ageGroupDiffOptions = {
  indexAxis: 'y',
  scales: {
    x: { stacked: true, display: false, max: 100 },
    y: { stacked: true, grid: { display: false }, ticks: { font: { size: 12, family: 'Kanit' } } },
  },
  plugins: {
    tooltip: { enabled: true },
  },
};

const fetchOverview = async () => {
  const res = await apiGet("cwdSurveys/dashboard/overview");
  if (res?.status === 200) {
    const data = res.data || {};
    totalCwd.value = toNumber(data.total_cwd);
    studyPct.value = toPercent(data.studying?.pct || 0);
    studyUnit.value = `${toNumber(data.studying?.count).toLocaleString("th-TH")} คน จากทั้งหมด`;
    
    neverStudyPct.value = toPercent(data.never_studied?.pct || 0);
    neverStudyUnit.value = `${toNumber(data.never_studied?.count || 0).toLocaleString("th-TH")} คน จากทั้งหมด`;

    earlyPrepPct.value = toPercent(data.pre_school?.pct || 0);
    earlyPrepUnit.value = `${toNumber(data.pre_school?.count || 0).toLocaleString("th-TH")} คน จากทั้งหมด`;

    const parentData = data.by_parent_gender || [];
    // if (parentData.length) {
      const labels = parentData.map((i) => i.parent || "");
      const female = parentData.map((i) => Number(i.female_count || 0));
      const male = parentData.map((i) => Number(i.male_count || 0));
      caregiverData.value = {
        labels,
        datasets: [
          bar("เพศหญิง", PALETTE[0], female, { barPercentage: 0.85, categoryPercentage: 0.6 }),
          bar("เพศชาย", PALETTE[1], male, { barPercentage: 0.85, categoryPercentage: 0.6 }),
        ],
      };
    // }
  }
};

const fetchHealth = async () => {
  const res = await apiGet("cwdSurveys/dashboard/health");
  if (res?.status === 200) {
    const data = res.data || {};

    statDiseasePct.value = toPercent(data.congenital?.pct)
    statDiseaseUnit.value = `${toNumber(data.congenital?.count)} คน`
    statSocialPct.value = toPercent(data.adaptation?.pct)
    statSocialUnit.value = `${toNumber(data.adaptation?.count)} คน`
    statAdhdPct.value = toPercent(data.hyperactivity?.pct)
    statAdhdUnit.value = `${toNumber(data.hyperactivity?.count)} คน`
    statIllPct.value = toPercent(data.severe_illness?.pct)
    statIllUnit.value = `${toNumber(data.severe_illness?.count)} คน`
    statVaccinePct.value = toPercent(data.vaccine?.pct)
    statVaccineUnit.value = `${toNumber(data.vaccine?.count)} คน`
    statTreatPct.value = toPercent(data.continuous_care?.pct)
    statTreatUnit.value = `${toNumber(data.continuous_care?.count)} คน`
    statDevPct.value = toPercent(data.development?.pct)
    statDevUnit.value = `${toNumber(data.development?.count)} คน`
    
    const avg_weight_height = data.avg_weight_height || [];
    // if (avg_weight_height.length) {
      const ageOrder = ["0-2 ปี", "3-5 ปี", "12-15 ปี", "16-18 ปี"];
      growthData.value = {
        labels: ageOrder,
        datasets: [
          bar("เด็กพิการ น้ำหนัก (kg)", PALETTE[0], ageOrder.map((age) => toNumber(avg_weight_height.find((i) => i.age_group === age)?.cwd?.avg_weight || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
          bar("เด็กพิการ ส่วนสูง (cm)", PALETTE[1], ageOrder.map((age) => toNumber(avg_weight_height.find((i) => i.age_group === age)?.cwd?.avg_height || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
          bar("ทั่วไป น้ำหนัก (kg)", PALETTE[2], ageOrder.map((age) => toNumber(avg_weight_height.find((i) => i.age_group === age)?.general?.avg_weight || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
          bar("ทั่วไป ส่วนสูง (cm)", PALETTE[3], ageOrder.map((age) => toNumber(avg_weight_height.find((i) => i.age_group === age)?.general?.avg_height || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
        ],
      };
    // }

    const DISEASE_LABELS = [
      "ความผิดปกติระบบประสาท",
      "NCDs (เบาหวาน ความดัน)",
      "โรคเกี่ยวกับเบาวัธยะ",
      "โรคติดเชื้อ",
      "บาดเจ็บร้ายแรง",
      "อื่น",
    ];
    const by_illness = data.by_congenital_illness || [];
    // if (by_illness.length) {
      const counts = DISEASE_LABELS.map((label) => {
        const found = by_illness.find((i) => label.includes(i.value) || i.value === label);
        return toNumber(found?.count || 0);
      });
      diseaseGroupData.value = hbar(DISEASE_LABELS, counts, "#d6b170");
    // }

    const tb = data.by_continuous_care_reason || [];
    if(tb.length) treatmentBarriers.value = makeProgressItems(tb);
    else treatmentBarriers.value = []

    const by_behavior = data.by_behavior || [];
    // if (by_behavior.length) {
    behaviorData.value = {
      labels: by_behavior.map((i) => i.behavior || ""),
      datasets: [
        bar("เด็กพิการ", "#5b7fc7", by_behavior.map((i) => toNumber(i.cwd || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
        bar("เด็กทั่วไป", "#3A506A", by_behavior.map((i) => toNumber(i.general || 0)), { barPercentage: 0.85, categoryPercentage: 0.6 }),
      ],
    };
    // }

    const dt = data.by_disability_type|| [];
    if(dt.length) devByType.value = makeProgressItems(dt);
    else devByType.value = []
  }
};

const fetchWelfare = async () => {
  const res = await apiGet("cwdSurveys/dashboard/welfare");
  if (res?.status === 200) {
    const data = res.data || {};

    const by_welfare = data.by_welfare || [];
    // if (by_welfare.length) {
      welfare.value = {
        labels: by_welfare.map((i) => i.value || ""),
        series: by_welfare.map((i) => toNumber(i.count)),
      };
    // }

    const received = data.disability_allowance?.received || {}
    // if (received) {
      allowanceReceivePct.value = toNumber(received.pct || 0);
      allowanceReceiveCount.value = toNumber(received.count || 0);
    // }

    const notReceived = data.disability_allowance?.not_received || {}
    // if (notReceived) {
      allowanceNotReceivePct.value = toNumber(notReceived.pct || 0);
      allowanceNotReceiveCount.value = toNumber(notReceived.count || 0);
    // }

    const ar = data.allowance_not_received_reason || [];
    if (ar.length) allowanceReasons.value = makeProgressItems(ar);
    else allowanceReasons.value = []
  }
};

const fetchSupport = async () => {
  const res = await apiGet("cwdSurveys/dashboard/support");
  if (res?.status === 200) {
    const data = res.data || {};

    const kpis = [
      {name: "ต้องรักษาต่อเนื่อง", ...data.continuous_care},
      {name: "มีบัตรคนพิการ", ...data.disabled_card},
      {name: "ใช้แว่นตา/คอนแทคเลนส์", ...data.eye_equipment},
      {name: "ใช้เครื่องช่วยฟัง", ...data.hearing_aid},
      {name: "ใช้เครื่องช่วยเดิน", ...data.walking_aid}];
    if (kpis.length) {
      healthAssistKpis.value = kpis.map((i) => ({
        label: i.name,
        value: toPercent(i.pct),
        sub: `${toNumber(i.count).toLocaleString("th-TH")} คน จากทั้งหมด`,
      }));
    }


    const commuData = data.communication || {};
    const cdUnderstand = commuData.understand || [];
    const cdComm = commuData.communication || [];
    // if (cdUnderstand.length || cdComm.length) {
      const COMM_LEVELS = ["ไม่มี", "มีความลำบากเล็กน้อย", "มีความลำบากมาก", "ไม่เข้าใจเลย"];
      const COMM_LEVEL_COLOR = {
        "ไม่มี": "#11D67A",
        "มีความลำบากเล็กน้อย": "#F4D35E",
        "มีความลำบากมาก": "#FE9000",
        "ไม่เข้าใจเลย": "#F73C4B",
      };
      const getVal = (arr, level) => toNumber(arr.find((i) => i.value === level)?.pct || 0);
      commDiffData.value = {
        labels: ["การเข้าใจ", "การสื่อสาร"],
        datasets: COMM_LEVELS.map((lv) =>
          bar(lv, COMM_LEVEL_COLOR[lv], [getVal(cdUnderstand, lv), getVal(cdComm, lv)], { barPercentage: 0.85, categoryPercentage: 0.9 }),
        ),
      };
    // }

    const DIFF_LEVELS = [
      { label: "ไม่มี",       match: (v) => v === "ไม่มี" || v.startsWith("ไม่มี") },
      { label: "มีความลำบากเล็กน้อย",  match: (v) => v.includes("เล็กน้อย") },
      { label: "มีความลำบากมาก",        match: (v) => v.includes("มาก") && !v.includes("เล็กน้อย") },
      { label: "ทำไม่ได้เลย",           match: (v) => v.includes("ไม่สามารถ") || v.includes("ทำไม่ได้") || v.includes("ไม่เข้าใจ") || v === "ทำไม่ได้เลย" },
    ];
    const DIFF_LEVEL_COLOR = {
      "ไม่มี": "#11D67A",
      "มีความลำบากเล็กน้อย": "#F4D35E",
      "มีความลำบากมาก": "#FE9000",
      "ทำไม่ได้เลย": "#F73C4B",
    };
    const buildDiffChart = (obj, keyLabels) => {
      const keys = Object.keys(keyLabels);
      return {
        labels: keys.map((k) => keyLabels[k]),
        datasets: DIFF_LEVELS.map(({ label, match }) =>
          bar(label, DIFF_LEVEL_COLOR[label],
            keys.map((k) => (obj[k] || []).filter((i) => match(i.value || "")).reduce((s, i) => s + toNumber(i.pct || 0), 0)),
            { barPercentage: 0.85, categoryPercentage: 0.9 },
          ),
        ),
      };
    };

    const hasItems = (obj) => Object.values(obj).some((arr) => Array.isArray(arr) && arr.length > 0);

    const age2_4 = data.age_2_4 || {};
    // if (hasItems(age2_4)) {
      age2_4Data.value = buildDiffChart(age2_4, {
        picking_up: "จับสิ่งของขนาดเล็ก",
        learning: "เรียนรู้สิ่งต่าง ๆ",
        play: "เล่น/ทำกิจกรรมต่าง ๆ",
      });
    // }

    const age5_17 = data.age_5_17 || {};
    // if (hasItems(age5_17)) {
      age5_17Data.value = buildDiffChart(age5_17, {
        self_care: "ดูแลตนเอง",
        make_friend: "ทำความรู้จัก/คบเพื่อนใหม่",
      });
    // }
  }
};

onMounted(() => {
  fetchOverview();
  fetchHealth();
  fetchWelfare();
  fetchSupport();
});

watch(filterParams, () => {
  fetchOverview();
  fetchHealth();
  fetchWelfare();
  fetchSupport();
}, { deep: true });
</script>
